(() => {
  'use strict';
  let gradientSequence = 0;
  const mount = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const input = root.querySelector('[data-badge-preview-input]');
    const text = root.querySelector('[data-badge-preview-text]');
    const svg = root.querySelector('[data-badge-preview-svg]');
    const error = root.querySelector('[data-badge-preview-error]');
    const label = root.querySelector('[data-badge-preview-color-label]');
    const stage = root.querySelector('[data-badge-preview-stage]');
    const fontSize = Number(text.getAttribute('font-size'));
    const width = 980;
    const gradient = root.querySelector('[data-badge-preview-gradient]');
    gradient.id = `BadgePreviewFlow${++gradientSequence}`;
    let frame = null;
    let flowActive = false;
    let phase = 0;
    let previousTime = null;
    const animateFlow = time => {
      if (!flowActive || !root.isConnected) { frame = null; previousTime = null; return; }
      if (previousTime !== null) phase = (phase + Math.min(time - previousTime, 100) * .08) % 480;
      previousTime = time;
      gradient.setAttribute('gradientTransform', `translate(${phase} 0)`);
      frame = requestAnimationFrame(animateFlow);
    };
    const setFlow = enabled => {
      flowActive = enabled;
      if (enabled && frame === null) frame = requestAnimationFrame(animateFlow);
      if (!enabled && frame !== null) { cancelAnimationFrame(frame); frame = null; previousTime = null; }
    };
    const draw = () => {
      const value = input.value.trim() || 'YOUR DESIGN';
      const color = root.querySelector('[data-badge-preview-color]:checked');
      text.textContent = value;
      text.setAttribute('font-size', String(fontSize));
      const flow = color.value === 'Flow RGB';
      text.setAttribute('fill', flow ? `url(#${gradient.id})` : color.dataset.color);
      setFlow(flow);
      text.setAttribute('x', '603');
      text.setAttribute('y', '645');
      const box = text.getBBox();
      const measured = Math.max(text.getComputedTextLength(), box.width);
      const fit = Math.min(1, width / Math.max(measured, 1), 78 / Math.max(box.height, 1));
      const rect = svg.getBoundingClientRect();
      const pixelRatio = Math.min(rect.width / svg.viewBox.baseVal.width, rect.height / svg.viewBox.baseVal.height);
      const minimum = Math.min(fontSize, 14 / Math.max(pixelRatio, .01));
      const tooLong = fontSize * fit < minimum;
      text.setAttribute('font-size', String(Math.max(minimum, fontSize * fit)));
      const fitted = text.getBBox();
      text.setAttribute('x', String(603 + 603 - (fitted.x + fitted.width / 2)));
      text.setAttribute('y', String(645 + 645 - (fitted.y + fitted.height / 2)));
      text.style.visibility = tooLong ? 'hidden' : 'visible';
      error.hidden = !tooLong;
      root.dataset.badgeTooLong = String(tooLong);
      input.setAttribute('aria-invalid', String(tooLong));
      svg.setAttribute('aria-label', tooLong ? 'License Plate Badge. Please shorten your text to fit the preview.' : `License Plate Badge with ${value} in ${color.value}`);
      label.textContent = color.value;
      if (flow && !tooLong) svg.setAttribute('aria-label', `License Plate Badge with ${value} in animated Flow RGB. Illustrative preview.`);
    };
    const showInputAndFrame = () => {
      if (!matchMedia('(max-width:767px)').matches || document.activeElement !== input) {
        root.style.removeProperty('--badge-preview-stage-height');
        return;
      }
      const viewport = window.visualViewport;
      const height = viewport?.height || window.innerHeight;
      const marginTop = height < 360 ? 12 : 72;
      const available = Math.max(142, height - marginTop - 94 - 20);
      root.style.setProperty('--badge-preview-stage-height', `${available}px`);
      requestAnimationFrame(() => {
        const frameRect = stage.getBoundingClientRect();
        const inputRect = input.getBoundingClientRect();
        const top = viewport?.offsetTop || 0;
        const bottom = top + height;
        if (frameRect.top < top + marginTop || inputRect.bottom > bottom - 12) {
          const delta = inputRect.bottom - frameRect.top + marginTop > height - 12
            ? inputRect.bottom - bottom + 12
            : frameRect.top - top - marginTop;
          window.scrollBy({top: delta, behavior: 'instant'});
        }
      });
    };
    const video = root.querySelector('[data-badge-preview-video]');
    const videoFrame = video.querySelector('iframe');
    video.addEventListener('toggle', () => {
      if (video.open) videoFrame.setAttribute('src', videoFrame.dataset.src);
      else videoFrame.removeAttribute('src');
    });
    input.addEventListener('input', () => { draw(); requestAnimationFrame(showInputAndFrame); });
    input.addEventListener('focus', () => requestAnimationFrame(showInputAndFrame));
    input.addEventListener('blur', () => root.style.removeProperty('--badge-preview-stage-height'));
    root.querySelectorAll('[data-badge-preview-color]').forEach(radio => radio.addEventListener('change', draw));
    window.visualViewport?.addEventListener('resize', showInputAndFrame);
    new ResizeObserver(draw).observe(stage);
    document.fonts?.ready.then(draw);
    draw();
  };
  const init = () => document.querySelectorAll('[data-lds-badge-text-preview]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
